import React from 'react'
import {translate} from 'react-i18next'
import {
  RingierBannerView,
  RingierBannerTitle,
  RingierBannerBenefit,
  RingierBannerBenefitIcon,
  RingierBannerBenefitMessage,
  RingierBannerBrandsContainer,
  RingierBannerOnelogLogo,
  RingierBannerOnelogTitle,
  RingierBannerGameImage,
} from './RingierBannerStyles'
import {LOGIN_CASES} from 'const'
import LogosSection from 'apps/hosted-login/logister-page/ringier-banner/RingierBannerLogoSection'

const getBenefitsByCase = loginCase => {
  const isSummitsCase = loginCase === LOGIN_CASES.BLICK.SUMMITS
  const isWinterAwardsCase = loginCase === LOGIN_CASES.BLICK.WINTER_AWARDS
  const isSkiTrophyCase = loginCase === LOGIN_CASES.BLICK.SKI_TROPHY_GAME
  const isMedaillenTrophyCase = loginCase === LOGIN_CASES.BLICK.MEDAILLEN_TROPHY_GAME
  const isIcehockeyCase = loginCase === LOGIN_CASES.BLICK.ICEHOCKEY_GAME
  const isEM2022Case = loginCase === LOGIN_CASES.BLICK.EM_2022_GAME
  const isEsaf2022Case = loginCase === LOGIN_CASES.BLICK.ESAF_2022_GAME
  const isSkiTrophy2223Case = loginCase === LOGIN_CASES.BLICK.SKI_TROPHY_2223_GAME
  const isUnihockeyWM2022Case = loginCase === LOGIN_CASES.BLICK.UNIHOCKEY_WM_2022_GAME
  const isSoccerWM2022Case = loginCase === LOGIN_CASES.BLICK.SOCCER_WM_2022_GAME
  const isBlickPrintAboshopCase = loginCase === LOGIN_CASES.BLICK.BLICKPRINT_ABOSHOP
  const isBlickJackpotCase = loginCase === LOGIN_CASES.BLICK.JACKPOT_2023_GAME
  const isEisHockeyWM2023Case = loginCase === LOGIN_CASES.BLICK.EISHOCKEY_WM_2023_GAME

  if (isSummitsCase) {
    return 'benefits-list-summits'
  }
  if (isWinterAwardsCase) {
    return 'benefits-list-winter-awards'
  }
  if (isSkiTrophyCase) {
    return 'benefits-list-ski-trophy'
  }
  if (isMedaillenTrophyCase) {
    return 'benefits-list-medaillen-trophy'
  }
  if (isIcehockeyCase) {
    return 'benefits-list-icehockey'
  }
  if (isEM2022Case) {
    return 'benefits-list-em2022'
  }
  if (isEsaf2022Case) {
    return 'benefits-list-esaf2022'
  }
  if (isSkiTrophy2223Case) {
    return 'benefits-list-ski-trophy-2223'
  }
  if (isUnihockeyWM2022Case) {
    return 'benefits-list-unihockey-wm-2022'
  }
  if (isSoccerWM2022Case) {
    return 'benefits-list-soccer-wm-2022'
  }
  if (isBlickPrintAboshopCase) {
    return 'benefits-list-blickprint-aboshop'
  }
  if (isBlickJackpotCase) {
    return 'benefits-list-jackpot-2023'
  }
  if (isEisHockeyWM2023Case) {
    return 'benefits-list-eishockey-wm-2023'
  }
  return 'benefits-list'
}

const getTitleByCase = loginCase => {
  const isSummitsCase = loginCase === LOGIN_CASES.BLICK.SUMMITS
  const isWinterAwardsCase = loginCase === LOGIN_CASES.BLICK.WINTER_AWARDS
  const isSkiTrophyCase = loginCase === LOGIN_CASES.BLICK.SKI_TROPHY_GAME
  const isMedaillenTrophyCase = loginCase === LOGIN_CASES.BLICK.MEDAILLEN_TROPHY_GAME
  const isIcehockeyCase = loginCase === LOGIN_CASES.BLICK.ICEHOCKEY_GAME
  const isEM2022Case = loginCase === LOGIN_CASES.BLICK.EM_2022_GAME
  const isEsaf2022Case = loginCase === LOGIN_CASES.BLICK.ESAF_2022_GAME
  const isSkiTrophy2223Case = loginCase === LOGIN_CASES.BLICK.SKI_TROPHY_2223_GAME
  const isUnihockeyWM2022Case = loginCase === LOGIN_CASES.BLICK.UNIHOCKEY_WM_2022_GAME
  const isSoccerWM2022Case = loginCase === LOGIN_CASES.BLICK.SOCCER_WM_2022_GAME
  const isBlickJackpotCase = loginCase === LOGIN_CASES.BLICK.JACKPOT_2023_GAME
  const isEisHockeyWM2023Case = loginCase === LOGIN_CASES.BLICK.EISHOCKEY_WM_2023_GAME

  if (isSummitsCase) {
    return 'ringier-banner.title-summits'
  }
  if (isWinterAwardsCase) {
    return 'ringier-banner.title-winter-awards'
  }
  if (isSkiTrophyCase) {
    return 'ringier-banner.title-ski-trophy-game'
  }
  if (isMedaillenTrophyCase) {
    return 'ringier-banner.title-medaillen-trophy-game'
  }
  if (isIcehockeyCase) {
    return 'ringier-banner.title-icehockey-game'
  }
  if (isEM2022Case) {
    return 'ringier-banner.title-em2022-trophy-game'
  }
  if (isEsaf2022Case) {
    return 'ringier-banner.title-esaf2022-trophy-game'
  }
  if (isSkiTrophy2223Case) {
    return 'ringier-banner.title-ski-trophy-2223-game'
  }
  if (isUnihockeyWM2022Case) {
    return 'ringier-banner.title-unihockey-wm-2022-game'
  }
  if (isSoccerWM2022Case) {
    return 'ringier-banner.title-soccer-wm-2022-game'
  }
  if (isBlickJackpotCase) {
    return 'ringier-banner.title-jackpot-2023-game'
  }
  if (isEisHockeyWM2023Case) {
    return 'ringier-banner.title-eishockey-wm-2023-game'
  }

  return 'ringier-banner.title'
}
const getBannerImage = image => {
  if (image) {
    return <RingierBannerGameImage src={image} />
  }

  return null
}

const mergeBenefits = (gameBenefits, t, loginCase) => {
  const list = getBenefitsByCase(loginCase)
  const defaultBenefits = t(`ringier-banner.${list}`, {returnObjects: true})
  if (!gameBenefits) {
    return defaultBenefits
  }

  return gameBenefits.map((benefit, idx) => benefit || defaultBenefits[idx])
}

const RingierBanner = ({loginCase, t, gameBanner = {}, gameImage}) => {
  const benefits = mergeBenefits(gameBanner.benefits, t, loginCase)

  return (
    <div>
      {getBannerImage(gameBanner.image || gameImage)}
      <RingierBannerView>
        <RingierBannerTitle>{gameBanner.title || t(getTitleByCase(loginCase))}</RingierBannerTitle>
        <div>
          {Array.isArray(benefits) &&
            benefits.map(line => (
              <RingierBannerBenefit key={line}>
                <RingierBannerBenefitIcon />
                <RingierBannerBenefitMessage>{line}</RingierBannerBenefitMessage>
              </RingierBannerBenefit>
            ))}
        </div>
        <RingierBannerBrandsContainer>
          <RingierBannerOnelogLogo />
          <RingierBannerOnelogTitle>{t('ringier-banner.logos-title')}</RingierBannerOnelogTitle>
          <LogosSection t={t} />
        </RingierBannerBrandsContainer>
      </RingierBannerView>
    </div>
  )
}

export default translate()(RingierBanner)
